import type { TFunction } from 'i18next';
import { InitiativeStatus } from '../../../../api/initiative-client/initiative-client.type';
import { primaryBase, redBase, skyDark, yellowBase } from '../../../../styles/design-tokens';

/**
 * Gets the color associated with an initiative status
 *
 * @param {InitiativeStatus} status - The initiative status to get the color for
 * @returns {string} The color string for the given status
 */
const getStatusColor = (status: InitiativeStatus): string => {
  switch (status) {
    case InitiativeStatus.OnTrack:
      return primaryBase;
    case InitiativeStatus.AtRisk:
      return yellowBase;
    case InitiativeStatus.OffTrack:
      return redBase;
    default:
      return skyDark;
  }
};

/**
 * Gets the label associated with an initiative status
 *
 * @param {InitiativeStatus} status - The initiative status to get the label for
 * @param {TFunction} t - Translation function from `useTranslation()`
 * @returns {string} The label string for the given status
 */
const getStatusLabel = (status: InitiativeStatus, t: TFunction): string => {
  switch (status) {
    case InitiativeStatus.OnTrack:
      return t('strategy.initiatives.statuses.on_track');
    case InitiativeStatus.AtRisk:
      return t('strategy.initiatives.statuses.at_risk');
    case InitiativeStatus.OffTrack:
      return t('strategy.initiatives.statuses.off_track');
    case InitiativeStatus.Unknown:
      return t('strategy.initiatives.statuses.unknown');
    case InitiativeStatus.Empty:
      return t('strategy.initiatives.statuses.empty');
    default:
      return status;
  }
};

export { getStatusColor, getStatusLabel };
